import App from '@app/app.js';
import mobileModal from './mobile-modal-window.html';
import './mobile-modal-window.scss';

class MobileModalWindowController {
  open = false;

  $onInit() {
    this.open = true;
  }

  onClose() {
    this.open = false;
    this.closeEvent();
  }
}

App.component('ltMobileModalWindow', {
  template: mobileModal,
  bindings: {
    title: '<',
    titleClass: '<',
    closeEvent: '&'
  },
  transclude: true,
  controller: MobileModalWindowController,
  controllerAs: 'modal'
});
